import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
    id: "app",
    class: "min-h-screen"
};
const _hoisted_2 = {
    key: 0,
    class: "mx-auto flex max-w-3xl items-center justify-end px-6 pt-10 pb-2"
};
import { computed } from "vue";
import { useRoute } from "vue-router";
import ErrorBoundary from "@/components/ErrorBoundary.vue";
import LanguageSwitcher from "@/components/LanguageSwitcher.vue";
// The donation-form routes (meta.bareLayout) render with ONLY their own layout — see the header
// comment. Other routes keep the opublic-front shell (header + page chrome).
export default /*@__PURE__*/ _defineComponent({
    __name: 'App',
    setup(__props) {
        const route = useRoute();
        const isBareLayout = computed(() => route.meta.bareLayout === true);
        return (_ctx, _cache) => {
            const _component_router_view = _resolveComponent("router-view");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (!isBareLayout.value)
                    ? (_openBlock(), _createElementBlock("header", _hoisted_2, [
                        _createVNode(LanguageSwitcher)
                    ]))
                    : _createCommentVNode("v-if", true),
                _createVNode(ErrorBoundary, null, {
                    default: _withCtx(() => [
                        (_openBlock(), _createBlock(_component_router_view, {
                            key: _unref(route).path
                        }))
                    ]),
                    _: 1 /* STABLE */
                })
            ]));
        };
    }
});
